import styles from './PaymentCompletedModalWindow.module.scss';
import Box from '@components/Box';
import CheckIcon from '@assets/icons/check_62.svg';
import { Button } from '@components/Button';
import { Column, Row } from '@components/Grid';
import { IPaymentCompletedModalWindowProps } from './types';
import { Text, TextColor, TextSize } from '@components/Text';
import { TextWeight } from '@components/Text';
import { useTranslation } from 'react-i18next';

const PaymentCompletedModalWindow: React.FC<IPaymentCompletedModalWindowProps> = (props: IPaymentCompletedModalWindowProps): React.ReactElement => {
  const {
    action,
    btnText,
    handlerSetIsOpenPaymentCompletedWindow,
    subTitle,
    title
  } = props;

  const { t } = useTranslation();

  return (
      <div className={styles.grid}>
        <Row>
          <Column phone={12}>
            <Box pb={8}>
              <img
                  src={CheckIcon}
                  alt="check"
              />
            </Box>
          </Column>
        </Row>
        <Row justify="center">
          <Column phone={12}>
            <Box pb={8}>
              <Text
                  className={styles.info}
                  color={TextColor.PRIMARY}
                  size={TextSize.XL}
                  weight={TextWeight.SEMIBOLD}
              >
                {title}
              </Text>
            </Box>
          </Column>
        </Row>
        {subTitle && (
            <Row justify="center">
              <Column phone={12}>
                <Box pb={8}>
                  <Text
                      className={styles.info}
                      color={TextColor.PRIMARY}
                      size={TextSize.S}
                  >
                    {subTitle}
                  </Text>
                </Box>
              </Column>
            </Row>
        )}
        <Row noWrap>
          <Box>
            {action ? (
                <Button
                    onClick={() => action()}
                    title={btnText}
                />
            ) : (
                <Button
                    onClick={() => handlerSetIsOpenPaymentCompletedWindow(false)}
                    title={t('paymentCompletedModalWindow.buttonFinish')}
                />
            )}
          </Box>
        </Row>
      </div>
  );
};

export default PaymentCompletedModalWindow;